import React from "react";

import { useViewport } from "@/contexts/ViewportContext";
import { useAppNavigation } from "@/hooks/application/navigation";
import { usePromotions } from "@/hooks/domain/promotions";
import { useStoreTypes } from "@/hooks/domain/storeTypes";
import { useStores } from "@/hooks/domain/stores";
import { HomeNavigation } from "@/navigation/stacks/HomeStack";

import HomeMobile from "./Home.mobile";
import HomeWeb from "./Home.web";
import { HomeProps } from "./types";

const Home = () => {
  const { isWebMode } = useViewport();
  const { navigate } = useAppNavigation<HomeNavigation>();

  const { data: promotionList, isLoading: isLoadingPromotionList } = usePromotions();

  const { data: storeTypeList, isLoading: isLoadingStoreTypeList } = useStoreTypes();

  const {
    data: storeList,
    isLoading: isLoadingStoreList,
    hasNextPage,
    fetchNextPage,
  } = useStores();

  const onLoadMoreStores = () => {
    if (hasNextPage) {
      fetchNextPage();
    }
  };

  const onSelectStoreType: HomeProps["onSelectStoreType"] = (storeTypeId) => {
    navigate("storesByType", {
      typeId: storeTypeId,
    });
  };

  const onSelectStore: HomeProps["onSelectStore"] = (storeId) => {
    navigate("storeHome", { storeId });
  };

  const Screen = isWebMode ? HomeWeb : HomeMobile;

  return (
    <Screen
      promotionList={promotionList}
      isLoadingPromotionList={isLoadingPromotionList}
      storeTypeList={storeTypeList}
      isLoadingStoreTypeList={isLoadingStoreTypeList}
      storeList={storeList}
      isLoadingStoreList={isLoadingStoreList}
      onLoadMoreStores={onLoadMoreStores}
      onSelectStoreType={onSelectStoreType}
      onSelectStore={onSelectStore}
    />
  );
};

export default Home;
